import type { ReactElement } from 'react';
import { HeroRule } from '../shell';
import s from './PublicLoading.module.css';

/** While a sign-in page's loader runs: the dark ground and the flowing rule, nothing else. */
export function PublicLoading(): ReactElement {
  return (
    <div className={s.page} aria-busy="true">
      <HeroRule busy />
    </div>
  );
}
